export const environment = {
  production: true,
  apiUrl: 'https://talk2doctors.com/',
};
